import Vue from 'vue'
import vuex from 'vuex'

import test from './test'

Vue.use(vuex)

export default new vuex.Store({
  modules: {
    test             // 考试管理类
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js